import React from 'react';
import {
  BooleanField,
  BooleanInput,
  Create,
  Edit,
  EditButton,
  Filter,
  FormDataConsumer,
  List,
  maxLength,
  minLength,
  required,
  SaveButton,
  SearchInput,
  TextField,
  TextInput,
  Toolbar,
} from 'react-admin';
import { ZippityDatagrid, ZippitySimpleForm } from '../../components';
import CustomTitle from '../../components/CustomTitle';

const PaymentMethodFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
  </Filter>
);

export const PaymentMethodList = (props) => (
  <div>
    <List
      {...props}
      bulkActionButtons={false}
      filters={<PaymentMethodFilter />}
      sort={{ field: 'is_active', order: 'DESC' }}
      perPage={50}
    >
      <ZippityDatagrid>
        <TextField source="name" />
        <TextField source="short_description" />
        <TextField source="long_description" />
        <BooleanField source="is_internal" />
        <BooleanField source="is_active" />
        <EditButton />
      </ZippityDatagrid>
    </List>
  </div>
);

const validateString = [required(), minLength(2), maxLength(200)];

const EditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

export const PaymentMethodEdit = (props) => (
  <Edit
    title={<CustomTitle title="resources.payment-method.title" />}
    {...props}
  >
    <ZippitySimpleForm toolbar={<EditToolbar />}>
      <TextField validate={validateString} source="name" />
      <TextInput
        validate={validateString}
        source="short_description"
        fullWidth
      />
      <TextInput
        validate={validateString}
        source="long_description"
        fullWidth
      />
      <FormDataConsumer>
        {({ formData }) => {
          // Do not allow users to edit booleans if method is stripe or square
          if (!formData.is_stripe && !formData.is_square) {
            return (
              <>
                <BooleanInput source="is_internal" />
                <BooleanInput source="is_active" />
              </>
            );
          }
          return (
            <div>
              Please reach out to your Zippity contact if you want to
              enable/disable this payment method
            </div>
          );
        }}
      </FormDataConsumer>
    </ZippitySimpleForm>
  </Edit>
);

export const PaymentMethodCreate = (props) => (
  <Create {...props}>
    <ZippitySimpleForm redirect="list">
      <TextInput validate={validateString} source="name" />
      <TextInput
        validate={validateString}
        source="short_description"
        fullWidth
      />
      <TextInput
        validate={validateString}
        source="long_description"
        fullWidth
      />
      <BooleanInput source="is_internal" defaultValue={false} />
      <BooleanInput source="is_active" defaultValue />
    </ZippitySimpleForm>
  </Create>
);
